import {
  type ConversationDetailBlock,
  type ConversationDetailSection,
} from './ConversationTurnItem'

// Sections and blocks arrive without server ids, so a React key has to come
// from their content. Serializing the whole element covers every field that
// changes how it renders — a text variant, a collapse threshold, a list icon —
// so two elements collide only when they are genuinely identical, and the
// mapper drops those siblings. JSON escaping also keeps content that contains
// the separators we used to join by from forging a collision.
export const deriveDetailBlockKey = (block: ConversationDetailBlock): string =>
  JSON.stringify(block)

export const deriveDetailSectionKey = (
  section: ConversationDetailSection
): string => JSON.stringify(section)
